<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
                fxLayout="column" fxLayoutAlign="center center"
                fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                    fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    business
                </mat-icon>
                <span class="logo-text h1">
                    Total Disponível para Investimento
                </span>
            </div>
            <!-- / APP TITLE -->   

            <div class="add-product-button mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                <!-- ADD BUTTON -->
                <button mat-raised-button mat-icon-button [matMenuTriggerFor]="animals">
                    <mat-icon>settings_applications</mat-icon>
                </button>
                <!-- / ADD BUTTON -->
                <mat-menu #animals="matMenu">
                    <button mat-menu-item (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                        CONSULTAR SALDO
                    </button>
                    <button mat-menu-item (click)="getAllExport()">
                        <mat-icon>cloud_download</mat-icon>
                        EXPORTAR SALDO
                    </button>
                </mat-menu>
            </div>
            

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'>

                <ngx-datatable-column name="Conta" prop="numero_xp" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span style="cursor: pointer;" (click)="redirecionaCliente(row.id)">
                            <b>{{row.numero_xp}}</b>
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente" prop="nome" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-nome="value" ngx-datatable-cell-template>
                        {{nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Assessor" prop="assessor" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-assessor="value" ngx-datatable-cell-template>
                        {{assessor}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Escritório" prop="nome_fantasia" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-nome_fantasia="value" ngx-datatable-cell-template>
                        {{nome_fantasia}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Total Conta Corretora" prop="valor_disponivel" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-valor_disponivel="value" ngx-datatable-cell-template>
                        {{valor_disponivel | number : '1.2-2'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Boletado RV" prop="valor_boleta_rv" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ getValorRV(row) | number : '1.2-2'}} 
                    </ng-template>
                </ngx-datatable-column> 

                <ngx-datatable-column name="Boletado RF" prop="valor_boleta_renda_fixa" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-valor_boleta_renda_fixa="value" ngx-datatable-cell-template>
                        {{valor_boleta_renda_fixa | number : '1.2-2'}} 
                    </ng-template>
                </ngx-datatable-column>    
                
                <ngx-datatable-column name="Boletado COE" prop="valor_boleta_coe" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-valor_boleta_coe="value" ngx-datatable-cell-template>
                        {{valor_boleta_coe | number : '1.2-2'}} 
                    </ng-template>
                </ngx-datatable-column>  

                <ngx-datatable-column name="Total Disponivel" prop="valor_total" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-valor_total="value" ngx-datatable-cell-template>                        
                        <span [ngClass]="{'negativo': valor_total < 0  , 'positivo': valor_total > 0 }">
                            {{ valor_total | number : '1.2-2'}}
                        </span>
                    </ng-template>
                </ngx-datatable-column>            

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>